import React, { useState, useMemo } from 'react'
import { components } from 'react-select'
import styled, { keyframes, css } from 'styled-components'
import { isOverflown } from '../helpers'

const TextInnerAnimation = keyframes`
  0% { margin-left:0; }
  100% { margin-left: 100%; }
`

const TextContentAnimation = keyframes`
  0% { margin-left:0; }
  100% { margin-left: -100%; }
`

const AnimatedText = styled.div<{ animate: boolean | null }>`
  width: max-content;
  ${({ animate }) =>
    !animate &&
    css`
      animation: none !important;

      & > div {
        animation: none !important;
      }
    `}
`

const StyledOption = styled(components.Option)<{ wrap?: boolean }>`
  div& {
    position: relative;
    min-height: 40px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 4px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;

     ${({ wrap }) =>
       wrap
         ? css`
             white-space: break-spaces;
           `
         : css`
             white-space: nowrap;
           `}

    &:hover > ${AnimatedText}, &:focus > ${AnimatedText} {
      animation: ${TextInnerAnimation} 2.5s linear infinite alternate;

      & > div {
        animation: ${TextContentAnimation} 2.5s linear infinite alternate;
      }
    }
  }
`

export const OptionWithAnimatedText = ({ children, innerProps, ...props }: any) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  const overflown = useMemo(() => ref && isOverflown(ref), [ref])

  return (
    <StyledOption
      {...props}
      innerRef={setRef}
      innerProps={{
        ...innerProps,
        'data-test-id': props.value,
      }}
    >
      <AnimatedText animate={overflown}>
        <div>{children}</div>
      </AnimatedText>
    </StyledOption>
  )
}
export const Option = (props: any) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  const overflown = useMemo(() => ref && isOverflown(ref), [ref])

  const { innerProps, label } = props

  return (
    <StyledOption
      {...props}
      innerRef={setRef}
      innerProps={{
        ...innerProps,
        'data-test-id': props.value,
        title: overflown ? label : undefined,
      }}
    />
  )
}
export const OptionWithWrappedText = (props: any) => {
  const { innerProps, label } = props

  return (
    <StyledOption
      {...props}
      innerProps={{
        ...innerProps,
        'data-test-id': props.value,
        title: label,
      }}
      wrap
    />
  )
}
